export default __webpack_public_path__ + "static/media/coming-soon-dark.d13e9877.svg";